import { defineComponent as _defineComponent } from 'vue'
import { onMounted } from "vue";
import { store } from "@/store/store";
import { useRouter } from "vue-router";
import Auth from "@aws-amplify/auth";
import ResponseData from "@/types/ResponseData";
import UserInfoDataService from "@/services/UserInfoDataService";
import CognitoAuthService from "@/services/CognitoAuthService";
import { useI18n } from "vue3-i18n";

export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const i18n = useI18n();

// creates a reference to Vue router
const router = useRouter();

onMounted(function () {
  signIn();
});

/** sign in method that calls the @aws-amplify/auth */
const signIn = async () => {
  await Auth.currentAuthenticatedUser()
    .then(async () => {
      let currentSession = null;
      try {
        currentSession = await Auth.currentSession();
        store.dispatch("setIDToken", currentSession.idToken.jwtToken);
      } catch (sessError) {
        console.log(sessError);
      }
      CognitoAuthService.decodeToken({ token: currentSession.idToken.jwtToken })
        .then(() => {
          console.log("Current user get success");
          setUserSessionInfo(currentSession);
          router.push("/");
        })
        .catch((error) => {
          console.log("Failed to get current user");
          console.log(error);
          router.push("/ErrorPage");
        })
    })
    .catch((error2: any) => {
      console.log("No current user..go to sign in");
      console.log(error2);
      store.dispatch('signIn');
    });
};

/** calculates when user will be auto logged out */
const autoTimeout = (result: any) => {
  const seconds_timeout = 3600;

  // sets user login to expire after 1 hour
  const expirationDate = +result.idToken.payload["auth_time"] + seconds_timeout;
  console.log(
    "Auth Time " + +result.idToken.payload["auth_time"],
    " Expire Date " + expirationDate
  );
  var expires_millseconds =
    (expirationDate - +result.idToken.payload["auth_time"]) * 1000;
  console.log("Expires in milliseconds ", expires_millseconds);

  return expires_millseconds;
};

/** ユーザーセッション情報を取得してstoreに格納 */
const setUserSessionInfo = (session: any) => {
  // starts timer to auto logout after 1 hour
  setTimeout(function () {
    if (store.state.isAltLogin == true) {
      autoLogoutLogInsert();
    } else {
      store.dispatch("autoLogout");
      router.replace("/login");
    }
    alert("You have been automatically logged out");
  }, autoTimeout(session));

  store.dispatch("setSession", session);
  store.dispatch("setIDToken", session.getIdToken().getJwtToken());
  const userId = session.idToken.payload["identities"][0].userId;
  store.dispatch("setUsername", userId);
  store.dispatch("setIsAuthenticated", true);
  setUserInfo(userId);
};

/** ユーザー情報を取得してstoreに格納 */
const setUserInfo = (userId: any) => {
  UserInfoDataService.getUserInfo(userId)
    .then((response: ResponseData) => {
      const userInfo = response.data;
      store.dispatch("setEmail", userInfo.email);
      store.dispatch("setGivenName", userInfo.givenName);
      store.dispatch("setFamilyName", userInfo.familyName);
      store.dispatch("setStationCode", userInfo.stationCode);
      store.dispatch("setLoginNumber", userInfo.loginNumber);
      store.dispatch("setCompanyName", userInfo.companyName);
      store.dispatch("setTitle", userInfo.title);
      store.dispatch("setDepartment", userInfo.department);
      store.dispatch("setIsAltLoginAdmin", userInfo.altLoginAdmin > 0 ? true : false);
    })
    .catch((e: Error) => {
      console.log(e.message);
      router.push("/ErrorPage");
    });
};

/** 成り代わりログアウトの処理 */
const autoLogoutLogInsert = () => {
  /* 成り代わりログアウトのログを登録する */
  const userValue = store.state.oriLoginUserInfo[0];
  const param = {
    loginUserId: userValue.userId,
    controlNumber: userValue.loginNumber,
    accessLog: store.state.accessLog,
    targetUserId: store.getters.cognitoUserName,
    targetUserStation: store.getters.stationCode,
    loginState: "timeout"
  }
  UserInfoDataService.insertAlternativeLogin(param)
    .then((_) => {
      console.log("timeout logging success");
      store.dispatch("autoLogout");
      router.replace("/login");
    })
    .catch((e: Error) => {
      console.log(e);
      if (e.response.data.dbException != undefined) {
        const firstError = e.response.data.dbException[0];
        alert(i18n.t("err081") + i18n.t("err080").replace("errorMessageValue", firstError.message));
      } else {
        alert(i18n.t("err081") + i18n.t("err080").replace("errorMessageValue", e.response.data.message));
      }
      store.dispatch("autoLogout");
      router.replace("/login");
    });
};

const __returned__ = { i18n, router, signIn, autoTimeout, setUserSessionInfo, setUserInfo, autoLogoutLogInsert }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})